import { render, staticRenderFns } from "./ISwiper.vue?vue&type=template&id=c91c0c1a&scoped=true&"
import script from "./ISwiper.vue?vue&type=script&lang=js&"
export * from "./ISwiper.vue?vue&type=script&lang=js&"
import style0 from "./ISwiper.vue?vue&type=style&index=0&id=c91c0c1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c91c0c1a",
  null
  
)

export default component.exports